
import React from "react";
import { FormattedMessage } from "react-intl";
import Mask from "../../../../../../components/alert/mask";
import { BigButton } from "../../../../../../components/button";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import BottomToTop from "../../../../../../components/transitions/bottom-to-top";
import classes from './style.module.scss'
import useStyles from "isomorphic-style-loader/useStyles";


const RateMask = props => {
    useStyles(classes)
    const {showRateMask, setShowRateMask, showRateIframe, showRateIframeUrl, website, setShowRateIframe} = props

    return (
        <div className={classes.RateMaskPage}>
            {
                showRateMask &&
                <div>
                    <div className={classes.RateMaskBox}>
                        <div className={classes.RateMask}>
                            <Iconfont className={classes.rateMaskClose} onClick={() => setShowRateMask(false)}>&#xe7c9;</Iconfont>
                            <div className={classes.maskTitle}>
                                <FormattedMessage id="how_rate_website" values={{ website: website }}/>
                            </div>
                            <div className={classes.rateMaskStarBox} onClick={() => {
                                setShowRateIframe(true)
                                setShowRateMask(false)
                            }}>
                                <Iconfont className={classes.rateMaskStar}>&#xe76b;</Iconfont>
                                <Iconfont className={classes.rateMaskStar}>&#xe76b;</Iconfont>
                                <Iconfont className={classes.rateMaskStar}>&#xe76b;</Iconfont>
                                <Iconfont className={classes.rateMaskStar}>&#xe76b;</Iconfont>
                                <Iconfont className={classes.rateMaskStar}>&#xe76b;</Iconfont>
                            </div>
                            <div className={classes.rateTip}>
                                <FormattedMessage id="please_rate_by_stars" values={{ website: website }}/>
                            </div>

                            <BigButton className={classes.BigButton} onClick={() => {
                                setShowRateIframe(true)
                                setShowRateMask(false)
                            }}>
                                <FormattedMessage id="confirm" />
                            </BigButton>
                        </div>
                        <Mask onClick={() => setShowRateMask(false)}/>
                    </div>
                </div>
            }

            <div>
                <BottomToTop in={showRateIframe} className={classes.TransitionBox}>
                    <div>
                        <div className={classes.AlertFrame}>
                            <iframe seamless="seamless" src={showRateIframeUrl}></iframe>
                            {
                                showRateIframe &&
                                <span className={classes.close} onClick={() => {
                                    setShowRateIframe(false)
                                }}><FormattedMessage id="close" /></span>
                            }
                        </div>
                    </div>
                </BottomToTop>
            </div>
        </div>
    )
}

export default RateMask